import { render, staticRenderFns } from "./TrabalheConosco.vue?vue&type=template&id=7c4bc677&scoped=true&"
import script from "./TrabalheConosco.vue?vue&type=script&lang=js&"
export * from "./TrabalheConosco.vue?vue&type=script&lang=js&"
import style0 from "./TrabalheConosco.vue?vue&type=style&index=0&id=7c4bc677&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4bc677",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VLayout})
